import { useState } from 'react';
import Check from '@mui/icons-material/CheckBox';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';
import { DeloitteTerms } from './deloitte-terms';
import { PageContainer } from '@/components/shared/page-container';
import { useNotification } from '@/context/notification';
import { useAcceptTerms } from '@/data/terms';
import { useUser } from '@/data/user';
import { useSetTitle } from '@/hooks/use-set-title';

export const Terms = () => {
  useSetTitle('Termos de uso e política de privacidade');
  const navigate = useNavigate();
  const { toast } = useNotification();
  const { user } = useUser();
  const { mutate: acceptTerms, isPending } = useAcceptTerms();
  const [accepted, setAccepted] = useState(false);
  const [pdfLoaded, setPdfLoaded] = useState(false);

  const isDeloitte = user?.colaborador.empresa.empresa === 'Deloitte';
  const termsAccepted = user?.terms_accepted;

  const onAcceptTerms = () => {
    if (!accepted) {
      toast({
        content:
          'Você deve indicar abaixo que leu, e que concorda com os Termos de Uso e Política de Privacidade.',
        type: 'error',
      });
      return;
    }

    acceptTerms(undefined, {
      onSuccess: () => navigate('/', { replace: true }),
      onError: () => {
        toast({ content: 'Erro ao aceitar os termos', type: 'error' });
      },
    });
  };

  return (
    <PageContainer noGutter sx={{ mb: 0 }}>
      <Stack height={isDeloitte ? 'auto' : '90vh'}>
        <Box
          sx={{
            width: { xs: '100%', md: '80%' },
            height: '100%',
            margin: '0 auto',
          }}
        >
          {isDeloitte ? (
            <DeloitteTerms />
          ) : (
            <Box sx={{ position: 'relative', height: '100%' }}>
              {!pdfLoaded && (
                <Stack
                  data-testid="terms-pdf-loading"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ position: 'absolute', inset: 0 }}
                >
                  <CircularProgress />
                </Stack>
              )}
              <iframe
                data-testid="terms-iframe"
                style={{
                  width: '100%',
                  height: '100%',
                }}
                src="https://assets.galena.com/edupass-api/public/termo-de-uso.pdf#view=FitH&toolbar=0&navpanes=0"
                onLoad={() => setPdfLoaded(true)}
              />
            </Box>
          )}
        </Box>
        <Stack alignItems="center" my={2} spacing={1}>
          {termsAccepted ? (
            <Stack direction="row" spacing={1}>
              <Typography color="success.main">
                Termos de Uso e Política de Privacidade aceitos
              </Typography>
              <Check color="success" />
            </Stack>
          ) : (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => setAccepted(e.target.checked)}
                    checked={accepted}
                  />
                }
                label={
                  <Typography>
                    Li e concordo com os Termos de Uso e Política de
                    Privacidade.
                  </Typography>
                }
              />
              <Button
                variant="contained"
                onClick={onAcceptTerms}
                disabled={!accepted}
                loading={isPending}
              >
                {isPending ? (
                  <CircularProgress size={20} color="secondary" />
                ) : (
                  'Enviar'
                )}
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </PageContainer>
  );
};
